// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { addDoc, collection, getFirestore } from "firebase/firestore";
// import { products } from "../data/asyncMock";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDx5rC5t8DSk0tOwZlAuu8itvvqYlYg4Q4",
  authDomain: "tiendademo-ee105.firebaseapp.com",
  projectId: "tiendademo-ee105",
  storageBucket: "tiendademo-ee105.appspot.com",
  messagingSenderId: "1079483731944",
  appId: "1:1079483731944:web:64d7b167284156887cde5d",
};

console.log("se conecta");
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// // Itera sobre cada elemento en el array 'products'
// products.forEach((product) => {
//   // addDoc recibe 2 parámetros, la referencia a la colección y datos del documento
//   // Crea una referencia a la colección "nuevos" en Firestore utilizando la instancia de Firestore 'db'
//   // El objeto 'product' contiene los datos que se agregarán como un nuevo documento en la colección

//   addDoc(collection(db, "nuevos"), product)
//     // Promesa que se resuelve cuando se completa la operación de agregar documento
//     .then((docRef) => {
//       // Imprime en la consola el ID del documento recién agregado
//       console.log(`Documento agregado con ID: ${docRef.id}`);
//     })
//     // Manejo de errores en caso de que la operación de agregar documento falle
//     .catch((err) => console.log(err));
// });
